<template>
  <div id="app">
    <template v-if="$route.path!=='/login'">
      <el-container>
        <el-header class="webHeader">
          <Header/>
        </el-header>
        <el-container class="subContainer">
          <el-aside width="200px" v-show="hasNav">
            <Navigator/>
          </el-aside>
          <el-main width="100%">
            <router-view id="appMain"/>
          </el-main>
        </el-container>
      </el-container>
      <!--
      <div class="wrapper" ref="wrapper" :style="{height: scrollerHeight}">

        <div class="wrap">

      </div>-->
      <!-- </div> -->
    </template>
    <template v-else>
      <router-view/>
    </template>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import Header from "@/components/header";
import Navigator from "@/components/navigator";
import {refreshToken, refresh} from "./common/base";
import {commonPRAS, initFunction} from "./common/constant";

export default {
  name: "App",
  components: {
    Header,
    Navigator
  },
  data() {
    return {
      isCollapse: true,
      oHeader: 0
    };
  },
  computed: {
    ...mapGetters(["hasNav"])
  },
  mounted() {
    // 添加可见性变化事件监听器
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    initFunction();
    // 全局初始化：拉取当前用户常驻站点（刷新时兜底触发；首次登录后由路由守卫触发；会话内幂等）
    const accessToken = localStorage.getItem(process.env.NODE_ENV + "_" + commonPRAS.tag + "_" + "accessToken");
    if (accessToken) {
      this.$store.dispatch("fetchDefaultBelong");
    }
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  watch: {},
  methods: {
    refreshToken,
    // 添加处理可见性变化的方法
    handleVisibilityChange() {
      if (document.visibilityState === 'visible' && localStorage.getItem(process.env.NODE_ENV + "_" + commonPRAS.tag + "_" + "accessToken")) {
        // 当页面变为可见时刷新
        refresh();
        console.log('页面重新获得焦点');
      }
    }
  }
};
</script>
<style>
html,
body,
#app,
.el-container {
  /* min-width: 1050px; */
  height: 100%;
  padding: 0;
}

.el-header,
.el-main {
  padding: 0 !important;
}

.el-aside {
  overflow-x: hidden !important;
}

.subContainer {
  height: 90vh;
}

.mr10 {
  margin-right: 10px;
}

.bd0 {
  border: 0;
}

.wrapper {
  position: relative;
}

.wrap {
  margin-left: 190px;
}

.tableWrap {
  padding-top: 20px;
}

.column {
  width: 94%;
  margin: 0 3%;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
}

.searchForm {
  width: 94%;
}

.contentHeader {
  height: auto !important;
  padding: 10px !important;
}

.footerHeight {
  height: auto !important;
}

.footerHeight .dialog-footer {
  margin: 20px 0 0 0;
  width: 100%;
}

.contentMain {
  height: 100%;
}

.search-btn {
  /* margin-bottom: 10px; */
}

.el-form-item {
  /* margin-bottom: 10px; */
}

.fullScreenDialog .el-dialog__headerbtn {
  background: url("./assets/close.png");
  float: left;
  position: relative;
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  background-size: cover;
  margin-right: 10px;
}

.fullScreenDialog .el-dialog__headerbtn i {
  display: none;
}

.webHeader {
  position: relative;
}

.isCollapse {
  position: absolute;
  right: 107px;
  top: 11px;
}

/* 设置整体表格样式 */

#appMain .table .el-table__cell {
  padding: 0;
}

#appMain .table th.el-table__cell > .cell {
  font-size: 12px !important;
  line-height: 12px;
  padding: 0 4px !important;
}

#appMain .table td.el-table__cell > div {
  line-height: 30px;
  font-size: 14px;
  padding: 0 4px !important;
}
#appMain .el-table .caret-wrapper {
  width: 10px
}
#appMain .el-table .sort-caret{
  left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue